namespace RioERP.Orders {
    export interface FranchiseeOrderProductsForm {
        OrderId: Serenity.LookupEditor;
        FranchiseeId: Serenity.LookupEditor;
        ProductId: Serenity.LookupEditor;
        OrderProductSpecificationId: Serenity.LookupEditor;
        Quantity: Serenity.IntegerEditor;
        Cost: Serenity.DecimalEditor;
        GrossAmount: Serenity.DecimalEditor;
        DiscountAmt: Serenity.DecimalEditor;
        NetAmount: Serenity.DecimalEditor;
        TaxableAmount: Serenity.DecimalEditor;
        TaxAmount: Serenity.DecimalEditor;
        SerialKey: Serenity.StringEditor;
        Note: Serenity.StringEditor;
        FranchiseeDiscountAmount: Serenity.DecimalEditor;
        FranchiseeDiscountValue: Serenity.DecimalEditor;
        EFranchiseeDiscountType: Serenity.EnumEditor;
    }

    export class FranchiseeOrderProductsForm extends Serenity.PrefixedContext {
        static formKey = 'Orders.FranchiseeOrderProducts';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!FranchiseeOrderProductsForm.init)  {
                FranchiseeOrderProductsForm.init = true;

                var s = Serenity;
                var w0 = s.LookupEditor;
                var w1 = s.IntegerEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.StringEditor;
                var w4 = s.EnumEditor;

                Q.initFormType(FranchiseeOrderProductsForm, [
                    'OrderId', w0,
                    'FranchiseeId', w0,
                    'ProductId', w0,
                    'OrderProductSpecificationId', w0,
                    'Quantity', w1,
                    'Cost', w2,
                    'GrossAmount', w2,
                    'DiscountAmt', w2,
                    'NetAmount', w2,
                    'TaxableAmount', w2,
                    'TaxAmount', w2,
                    'SerialKey', w3,
                    'Note', w3,
                    'FranchiseeDiscountAmount', w2,
                    'FranchiseeDiscountValue', w2,
                    'EFranchiseeDiscountType', w4
                ]);
            }
        }
    }
}
